// src/components/ScrollToTop.js
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const HEADER_OFFSET = 84; // navbar ki height (px). Navbar ke mutabiq badal sakte hain.
const MAX_FRAMES = 45;    // ~750ms tak late-loading content (fees, images, Swiper) ka intezar

// Browser ka apna scroll restore band karo (ek dafa)
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// Global smooth scroll ko bypass karke seedha jump karo
function jumpTo(top) {
  const html = document.documentElement;
  const prev = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";
  window.scrollTo(0, top);
  html.style.scrollBehavior = prev;
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    let active = true;
    let frame = 0;
    let count = 0;

    // User ne khud scroll / touch kiya to reset rok do
    const stop = () => {
      active = false;
    };
    window.addEventListener("wheel", stop, { passive: true, once: true });
    window.addEventListener("touchstart", stop, { passive: true, once: true });
    window.addEventListener("keydown", stop, { once: true });

    const place = () => {
      if (hash) {
        const el = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
          jumpTo(Math.max(top, 0));
        }
        return;
      }
      jumpTo(0);
    };

    const tick = () => {
      if (!active) return;
      place();
      if (++count < MAX_FRAMES) frame = requestAnimationFrame(tick);
    };

    tick();

    return () => {
      active = false;
      cancelAnimationFrame(frame);
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchstart", stop);
      window.removeEventListener("keydown", stop);
    };
  }, [pathname, hash]);

  return null;
}